export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/boston-cf898bc05df8da1a9fdd3fc7b8bd265a.jpg";